/* nombre dispositivo grupo subgrupo latitud longitud */
import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AuthContext from 'context/autentication/authContext';
import ClienteContext from 'context/cliente/clienteContext';
import {IconButton} from "@material-ui/core";
import { Role } from "types/roles";
import Tooltip from '@material-ui/core/Tooltip';

const rolIcon = "/SalirSoporteIcon.svg"


const useStyles = makeStyles((theme) => ({
    formularioFechas: {
        padding: theme.spacing(2),
    },
    formularioBotones: {
        margin: theme.spacing(1),
    },
    formularioLinkRapido: {
        fontSize: "0.8rem",
    },
    }));

export default function Soporte(props) {
    const classes = useStyles();
    //const classes = useStyles();
    const authContext = useContext(AuthContext);
    const { usuario, cliente, editarClienteDefault } = authContext;
    const clienteContext = useContext(ClienteContext);
    const {obtenerClientesSoporte } = clienteContext;
    const [users, setUsers]= useState()
    const armarSoporte = (value) =>{
        if (value){ 
            setUsers(value.data.usuariosPopulados.clienteRol.filter((us)=>us.rol===Role.Integrador))
        } 
    }
    useEffect(() => {
        if (cliente) {
            obtenerClientesSoporte(usuario._id).then(value=>armarSoporte(value))
    }
        // eslint-disable-next-line
    }, []);
    const cambiarUser = () => {
        editarClienteDefault(users[0]._id).then(value=>window.location.reload(true)) 
    }
    return (
        users ?  
            <Tooltip arrow title={<p style={{ fontSize: "12px", minWidth: 70, textAlign: "center" }}>Volver a Integrador</p>}>
                <IconButton color="inherit"  onClick={()=>cambiarUser()} >
                    <img src={rolIcon} style={{ width:"23px", height:"23px"}}/>
                </IconButton>
            </Tooltip>
            : null
    );
}